import styled from 'styled-components';

export const Badge = styled.span`
  background-color: ${props => props.color};
`;
